import React from "react";
import {
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import ThanksIllustration from "../../../assets/ThanksIllustration";

type PostCallMobileProps = {
  onScheduleAnother: () => void;
  onNoThanks: () => void;
};

export default function PostCallMobile({
  onScheduleAnother,
  onNoThanks,
}: PostCallMobileProps) {
  return (
    <SafeAreaView style={styles.root}>
      <View style={styles.content}>
        <ThanksIllustration
          width={216}
          height={216}
          style={styles.illustration}
        />

        <Text style={styles.title}>Nice job showing up!</Text>
        <Text style={styles.subtitle}>
          Every conversation is a step forward.
        </Text>

        <Text style={styles.prompt}>
          You can start the next one whenever you feel ready
        </Text>

        <View style={styles.actions}>
          <View style={styles.actionGroup}>
            <TouchableOpacity
              style={[styles.actionButton, styles.skipButton]}
              onPress={onNoThanks}
              activeOpacity={0.85}
            >
              <Ionicons name="close" size={26} color="#f6f7f9" />
            </TouchableOpacity>
            <Text style={styles.actionLabel}>Skip</Text>
          </View>
          <View style={styles.actionGroup}>
            <TouchableOpacity
              style={[styles.actionButton, styles.newButton]}
              onPress={onScheduleAnother}
              activeOpacity={0.85}
            >
              <Ionicons name="add" size={26} color="#f6f7f9" />
            </TouchableOpacity>
            <Text style={styles.actionLabel}>New</Text>
          </View>
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#232335",
  },
  content: {
    flex: 1,
    width: "100%",
    maxWidth: 375,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingTop: 48,
    paddingBottom: 40,
  },
  illustration: {
    marginBottom: 16,
  },
  title: {
    fontSize: 26,
    lineHeight: 28,
    fontWeight: "700",
    color: "#f6f7f9",
    textAlign: "center",
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 20,
    color: "#85858b",
    textAlign: "center",
    marginBottom: 24,
  },
  prompt: {
    fontSize: 16,
    lineHeight: 20,
    color: "#f6f7f9",
    textAlign: "center",
    marginBottom: 24,
  },
  actions: {
    flexDirection: "row",
    gap: 24,
  },
  actionGroup: {
    alignItems: "center",
    width: 84,
  },
  actionButton: {
    width: 56,
    height: 56,
    borderRadius: 28,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 8,
  },
  skipButton: {
    backgroundColor: "#e65c5c",
  },
  newButton: {
    backgroundColor: "#3a6fb1",
  },
  actionLabel: {
    fontSize: 12,
    fontWeight: "700",
    color: "#f6f7f9",
  },
});
